/**
 * String constants for EDMS Folder Types page.
 */

export const PAGE = {
  title: 'Folder Types',
  description:
    'Manage Folder Types used in the document management system. Use the filters below to refine the list.',
};

export const ACTIONS = {
  create: 'Create Folder Type',
  edit: 'Update Folder Type',
  delete: 'Delete Folder Type',
  cancel: 'Cancel',
};

export const SEARCH = {
  placeholder: 'Search folder types…',
  inputId: 'folder-type-search',
};

export const ACTIVE_FILTER = {
  selectId: 'folder-type-active',
};

export const MESSAGES = {
  createSuccess: 'Folder Type created successfully.',
  createError: 'Unable to create Folder Type. Please try again.',
  updateSuccess: 'Folder Type updated successfully.',
  updateError: 'Unable to update Folder Type. Please try again.',
  updateMissingId: 'Unable to update Folder Type: missing Folder Type identifier.',
  deleteSuccess: 'Folder Type deleted successfully.',
  deleteError: 'Unable to delete Folder Type. Please try again.',
};

export const CONFIRM = {
  updateTitle: 'Update Folder Type?',
  updateMessage: 'Apply the pending changes?',
  deleteTitle: 'Delete Folder Type?',
  deleteMessage: (name) =>
    `This will remove "${name || 'this Folder Type'}" and any linked records. This action cannot be undone.`,
};

export const SUCCESS_DIALOG = {
  successTitle: 'Success',
  errorTitle: 'Action required',
};
